!(function (e, t) {
  'object' == typeof exports && 'undefined' != typeof module
    ? (module.exports = t())
    : 'function' == typeof define && define.amd
      ? define(t)
      : ((e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}), (e.ReactIntlLocaleData.el = t()));
})(this, function () {
  'use strict';
  return [
    {
      locale: 'el',
      pluralRuleFunction: function (e, t) {
        return t ? 'other' : 1 == e ? 'one' : 'other';
      },
      fields: {
        year: {
          displayName: 'έτος',
          relative: { 0: 'φέτος', 1: 'επόμενο έτος', '-1': 'πέρσι' },
          relativeTime: {
            future: { one: 'σε {0} έτος', other: 'σε {0} έτη' },
            past: { one: 'πριν από {0} έτος', other: 'πριν από {0} έτη' }
          }
        },
        'year-short': {
          displayName: 'έτ.',
          relative: { 0: 'φέτος', 1: 'επόμενο έτος', '-1': 'πέρσι' },
          relativeTime: {
            future: { one: 'σε {0} έτος', other: 'σε {0} έτη' },
            past: { one: 'πριν από {0} έτος', other: 'πριν από {0} έτη' }
          }
        },
        month: {
          displayName: 'μήνας',
          relative: { 0: 'τρέχων μήνας', 1: 'επόμενος μήνας', '-1': 'προηγούμενος μήνας' },
          relativeTime: {
            future: { one: 'σε {0} μήνα', other: 'σε {0} μήνες' },
            past: { one: 'πριν από {0} μήνα', other: 'πριν από {0} μήνες' }
          }
        },
        'month-short': {
          displayName: 'μήν.',
          relative: { 0: 'τρέχων μήνας', 1: 'επόμενος μήνας', '-1': 'προηγούμενος μήνας' },
          relativeTime: {
            future: { one: 'σε {0} μήνα', other: 'σε {0} μήνες' },
            past: { one: 'πριν από {0} μήνα', other: 'πριν από {0} μήνες' }
          }
        },
        day: {
          displayName: 'ημέρα',
          relative: { 0: 'σήμερα', 1: 'αύριο', 2: 'μεθαύριο', '-2': 'προχθές', '-1': 'χθες' },
          relativeTime: {
            future: { one: 'σε {0} ημέρα', other: 'σε {0} ημέρες' },
            past: { one: 'πριν από {0} ημέρα', other: 'πριν από {0} ημέρες' }
          }
        },
        'day-short': {
          displayName: 'ημ.',
          relative: { 0: 'σήμερα', 1: 'αύριο', 2: 'μεθαύριο', '-2': 'προχθές', '-1': 'χθες' },
          relativeTime: {
            future: { one: 'σε {0} ημ.', other: 'σε {0} ημ.' },
            past: { one: 'πριν από {0} ημ.', other: 'πριν από {0} ημ.' }
          }
        },
        hour: {
          displayName: 'ώρα',
          relative: { 0: 'τρέχουσα ώρα' },
          relativeTime: {
            future: { one: 'σε {0} ώρα', other: 'σε {0} ώρες' },
            past: { one: 'πριν από {0} ώρα', other: 'πριν από {0} ώρες' }
          }
        },
        'hour-short': {
          displayName: 'ώ.',
          relative: { 0: 'τρέχουσα ώρα' },
          relativeTime: {
            future: { one: 'σε {0} ώ.', other: 'σε {0} ώ.' },
            past: { one: 'πριν από {0} ώ.', other: 'πριν από {0} ώ.' }
          }
        },
        minute: {
          displayName: 'λεπτό',
          relative: { 0: 'τρέχον λεπτό' },
          relativeTime: {
            future: { one: 'σε {0} λεπτό', other: 'σε {0} λεπτά' },
            past: { one: 'πριν από {0} λεπτό', other: 'πριν από {0} λεπτά' }
          }
        },
        'minute-short': {
          displayName: 'λεπ.',
          relative: { 0: 'τρέχον λεπτό' },
          relativeTime: {
            future: { one: 'σε {0} λεπ.', other: 'σε {0} λεπ.' },
            past: { one: 'πριν από {0} λεπ.', other: 'πριν από {0} λεπ.' }
          }
        },
        second: {
          displayName: 'δευτερόλεπτο',
          relative: { 0: 'τώρα' },
          relativeTime: {
            future: { one: 'σε {0} δευτερόλεπτο', other: 'σε {0} δευτερόλεπτα' },
            past: { one: 'πριν από {0} δευτερόλεπτο', other: 'πριν από {0} δευτερόλεπτα' }
          }
        },
        'second-short': {
          displayName: 'δευτ.',
          relative: { 0: 'τώρα' },
          relativeTime: {
            future: { one: 'σε {0} δευτ.', other: 'σε {0} δευτ.' },
            past: { one: 'πριν από {0} δευτ.', other: 'πριν από {0} δευτ.' }
          }
        }
      }
    },
    { locale: 'el-CY', parentLocale: 'el' }
  ];
});
